<div class="fill-height-box-chat-v2-min-height workspace-page">
  <div class="container-fluid">
    <div class="container p-0 content-space-1 mt-4">

      <!-- Greeting / Context -->
      <div class="hero-banner">
        <h2 class="hero-title">
          Hi {{ activeAccount?.user?.name | titlecase }}!
          <span class="hero-sub">You are currently in
            <strong>{{ activeAccount?.account?.accountName | titlecase }}</strong>
            @if (activeAccount?.account?.accountType != 'TEAM') {
              <span class="hero-pill">Trial</span>
            }
            Workspace
          </span>
        </h2>
      </div>

      <div class="row">
        <!-- Switch Workspace -->
        <div class="col-sm-8 col-lg-8 mb-5 mb-lg-10">
          <div class="section-header clickable">
            <i class="bi bi-building section-icon"></i>
            <h2 class="section-title">Switch Workspace</h2>
          </div>

          <div class="workspace-grid">
            @for (item of accounts; track item) {
              <div class="workspace-card" (click)="changeActiveAccount(item)">
                <div class="workspace-card__body">
                  <h5 class="workspace-card__title">
                    {{ item.account.accountName | titlecase }}
                  </h5>
                  @if (item.isExpired === true) {
                    <span class="badge badge-danger">Trial Expired</span>
                  }
                </div>
              </div>
            }
          </div>

          @if (!accounts || accounts.length === 0) {
            <h4 class="empty-state">
              You are not part of any other workspace currently.
            </h4>
          }
        </div>

        <!-- Quick Actions + Integrations -->
        <div class="col-sm-4 col-lg-4 mb-5 mb-lg-10">
          <div class="section-header clickable">
            <i class="bi bi-bookmark-star-fill section-icon"></i>
            <h2 class="section-title">Quick Actions</h2>
          </div>

          <ul class="qa-list">
            <li class="qa-item">
              <a class="qa-link" (click)="changeRegisteredNumber()">Change Your Registered Number</a>
            </li>
            <li class="qa-item">
              <a class="qa-link"
                (click)="closeDialog()"
                [routerLink]="['/account/profile', { outlets: { 'profile': ['profile-detail'] } }]">
                View/Edit Your Profile
              </a>
            </li>
            <li class="qa-item">
              <a class="qa-link" (click)="showProfilePicUpload()">Change Profile Picture</a>
            </li>
            <li class="qa-item">
              <a class="qa-link" (click)="manageWorkspace()">Manage Workspace Memberships</a>
            </li>
            <li class="qa-item qa-item--notification">
              <details class="notification-health">
                <summary class="qa-link notification-health__compact">
                  <span>Check Notification Setup</span>
                  <i class="bi bi-chevron-down notification-health__chevron" aria-hidden="true"></i>
                </summary>

                <div class="notification-health__details" aria-labelledby="notification-health-title">
                  <div class="notification-health__toolbar">
                    <div>
                      <h2 id="notification-health-title" class="notification-health__title">Notification check</h2>
                      <p class="notification-health__meta" aria-live="polite">
                        {{ pushDiagnosticsLoading ? 'Checking this browser...' : pushDiagnosticSummary }}
                        @if (pushDiagnosticsCheckedAt) { &middot; Checked at {{ pushDiagnosticsCheckedAt }} }
                      </p>
                    </div>
                    <div class="notification-health__actions">
                      @if (canRepairPushIdentity) {
                        <button
                          type="button"
                          class="notification-health__button notification-health__button--secondary"
                          [disabled]="pushDiagnosticsLoading"
                          (click)="repairPushIdentity()">
                          <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
                          Repair identity
                        </button>
                      }
                      <button
                        type="button"
                        class="notification-health__button"
                        [disabled]="pushDiagnosticsLoading"
                        (click)="runPushDiagnostics()">
                        <i class="bi bi-activity" aria-hidden="true"></i>
                        {{ pushDiagnosticsLoading ? 'Checking...' : 'Run again' }}
                      </button>
                    </div>
                  </div>

                  @if (pushDiagnosticsError) {
                    <div class="notification-health__error" role="alert">{{ pushDiagnosticsError }}</div>
                  }

                  @if (pushDiagnosticsLoading && pushDiagnosticChecks.length === 0) {
                    <div class="notification-health__loading" aria-label="Checking notification health">
                      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                      Inspecting notification settings&hellip;
                    </div>
                  }

                  @if (pushDiagnosticChecks.length > 0) {
                    <div class="notification-health__checks" role="list" aria-label="Notification diagnostic results">
                      @for (check of pushDiagnosticChecks; track check.key) {
                        <article
                          class="notification-check"
                          [ngClass]="'notification-check--' + check.severity"
                          role="listitem">
                          <div class="notification-check__status" aria-hidden="true">
                            @switch (check.severity) {
                              @case ('success') { <i class="bi bi-check-circle-fill"></i> }
                              @case ('warning') { <i class="bi bi-exclamation-triangle-fill"></i> }
                              @case ('error') { <i class="bi bi-x-circle-fill"></i> }
                              @default { <i class="bi bi-info-circle-fill"></i> }
                            }
                          </div>
                          <div class="notification-check__content">
                            <div class="notification-check__result">
                              <h3 class="notification-check__label">{{ check.label }}</h3>
                              <span class="notification-check__value">{{ check.value }}</span>
                            </div>
                            @if (check.recommendation) {
                              <p class="notification-check__recommendation">
                                <span class="visually-hidden">Recommendation: </span>{{ check.recommendation }}
                              </p>
                            }
                          </div>
                        </article>
                      }
                    </div>
                  }
                </div>
              </details>
            </li>
            <li class="qa-item danger">
              <a class="qa-link danger" (click)="signOut()">Sign Out of Salesmax</a>
            </li>
          </ul>

          <!-- User Level Integrations -->
          <div class="section-header mt-4">
            <i class="bi bi-plug-fill section-icon"></i>
            <h3 class="section-title h3">Integrations</h3>
          </div>

          <div class="integrations-stack">
            @for (integration of integrationList; track integration) {
              <div class="integration-card card-int card-flush-int p-2"
                   [ngClass]="{
                     'connected-card'    : integrationStatusConnected && integrationStatusConnected[integration.id] && integrationStatusConnected[integration.id].length > 0,
                     'pending-issue-card': (integrationActionStatus && integrationActionStatus[integration.id]) || (errorNetwrokLevel && errorNetwrokLevel[integration.id] && errorNetwrokLevel[integration.id].length > 0)
                   }">
                <div class="integration-card__row">
                  <div class="integration-card__media d-none d-lg-flex">
                    <img class="integration-card__img" [src]="integration.image" [alt]="integration.name" />
                  </div>
                  <div class="integration-card__body">
                    <div class="integration-card__title-row">
                      <h2 class="integration-card__title mb-0">{{ integration.name }}</h2>
                      @if (integrationStatusConnected && integrationStatusConnected[integration.id] && integrationStatusConnected[integration.id].length > 0) {
                        <span
                          class="badge badge-light-primary fw-bold">
                          Connected
                          @if (integration.id != 'WHATSAPP_BUSINESS_LOGIN') {
                            – {{ integrationStatusConnected[integration.id].length }}
                          }
                        </span>
                      }
                    </div>
                    <div class="integration-card__desc">
                      {{ integration.description }}
                    </div>
                    <div class="integration-card__action">
                      @if (!((integration.id == 'WHATSAPP_BUSINESS_LOGIN' && connectedWabaAccounts.length > 0)
                        || (integrationStatus && integrationStatus[integration.id] && integrationStatus[integration.id].length > 0))) {
                        <a class="integration-link"
                          (click)="goToIntegration(integration)">
                          {{ integration.actionText }}
                        </a>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
